import TeamAssistMessage from 'models/team_assist_message';

export default class RetryTeamAssist {
  constructor(context) {
    this.context = context;
  }

  run({ customerId, messageId }) {
    if (!customerId) {
      return;
    }
    if (!messageId) {
      return;
    }

    if (!this.context.stores.customers.has({ id: customerId })) {
      return;
    }

    const store = this.context.stores.customers.storesFor(customerId).teamAssists;
    const message = store.find(messageId);
    if (message) {
      store.addOrReplace(
        TeamAssistMessage.fromJs({
          ...message.toJs(),
          isRetrying: true,
        })
      );
    }

    this.context.gateways.teamAssist.retry({ customerId, messageId });
  }
}
